import { render } from "./LoadingOverlay.vue?vue&type=template&id=6155d3a6&scoped=true"
import script from "./LoadingOverlay.vue?vue&type=script&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&lang=js"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=6155d3a6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6155d3a6"

export default script